module.exports = __webpack_public_path__ + "static/media/btg_01.1e661a05.png";